// shared module used by both public and admin
(function () {
    'use strict';
    angular.module('sharedModule', [])
})();